<template>
    <div>
        <!--        <div class="md-layout md-alignment-center-right">-->
        <!--            <div class="md-layout-item md-size-15">-->
        <!--                <md-field>-->
        <!--                    <label>设备名称</label>-->
        <!--                    <md-input v-model="newDeviceName" placeholder="输入设备名称"></md-input>-->
        <!--                </md-field>-->
        <!--            </div>-->
        <!--            <div class="md-layout-item md-size-15">-->
        <!--                <md-field>-->
        <!--                    <label>序列号</label>-->
        <!--                    <md-input v-model="newDeviceSn" placeholder="输入序列号"></md-input>-->
        <!--                </md-field>-->
        <!--            </div>-->
        <!--            <div class="md-layout-item md-size-10" id="add_new">-->
        <!--                <md-button class="md-raised md-primary" @click="addDevice">添加新设备</md-button>-->
        <!--            </div>-->
        <!--        </div>-->

        <div class="md-layout md-alignment-center-right">
            <div class="md-layout-item md-size-15">
                <md-field>
                    <label for="fromWhere">设备状态</label>
                    <md-select v-model="fromWhere" name="fromWhere" id="fromWhere">
                        <md-option value="0">所有</md-option>
                        <md-option value="1">用户未启用</md-option>
                        <md-option value="-1">EXCEL未启用</md-option>
                        <md-option value="2">App自动激活</md-option>
                        <md-option value="3">用户已启用</md-option>
                    </md-select>
                </md-field>
            </div>
            <div class="md-layout-item md-size-30">
                <md-field md-clearable>
                    <label>序列号</label>
                    <md-input v-model="searchDeviceSn" placeholder="输入序列号搜索"></md-input>
                </md-field>
            </div>

        </div>

        <div class="md-layout md-alignment-center-right">
            <div class="block">
                <span class="demonstration">起止时间：</span>
                <el-date-picker
                        v-model="filterTime"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                </el-date-picker>
            </div>
        </div>

        <div class="md-layout md-alignment-center-right">
            <div class="md-layout-item md-size-10" id="device_search">
                <md-button class="md-raised md-primary" @click="searchDevice">搜索设备</md-button>
            </div>
        </div>

        <md-table>
            <md-table-toolbar>
                <div class="md-toolbar-section-end" id="toolbar_show" v-show="selectedDevices.length !== 0">
                    <md-button class="md-primary" @click="lockUnlockDevices(true)">全部冻结</md-button>
                    <md-button class="md-primary" @click="lockUnlockDevices(false)">全部解除冻结</md-button>
                    <md-button class="md-primary" @click="deleteDevices()">全部删除</md-button>
                </div>
            </md-table-toolbar>
            <md-table-row>
                <md-checkbox v-model="allSelected" @change="selectAll"></md-checkbox>
                <md-table-head class="table_head">序号</md-table-head>
                <md-table-head class="table_head">设备名称</md-table-head>
                <md-table-head class="table_head">设备序列号</md-table-head>
                <md-table-head class="table_head">设备状态</md-table-head>
                <md-table-head class="table_head">添加时间</md-table-head>
                <md-table-head class="table_head">备注</md-table-head>
                <md-table-head class="table_head">操作</md-table-head>
            </md-table-row>

            <md-table-row
                    v-for="(item, index) in filterDevices"
                    v-bind:key="item.serial_number">
                <md-checkbox v-model="selectedDevices" v-bind:value="filterDevices[index].serial_number"
                             @change="changeSelect"></md-checkbox>
                <md-table-cell>{{ (index + 1) + (page - 1) * count }}</md-table-cell>
                <md-table-cell>{{ item.device_name }}</md-table-cell>
                <md-table-cell>{{ item.serial_number }}</md-table-cell>
                <md-table-cell>{{ getReadableFrom(item['from']) }}</md-table-cell>
                <md-table-cell>{{ new Date(item.insert_time).toLocaleString() }}</md-table-cell>
                <md-table-cell>{{ item.remarks }}</md-table-cell>
                <md-table-cell>
                    <md-button class="md-accent" @click="lockUnlockDevice(item.serial_number, !item.freeze)">
                        {{item.freeze?'已冻结':'正常'}}
                    </md-button>
                    <md-button class="md-primary" @click="getActivatedUsers(item.id)"
                               v-if="roleAdmin && (item.from === 2 || item.from === 3)">查询用户
                    </md-button>
                    <md-button class="md-primary" @click="deleteDeviceQuery(index)"
                               v-if="roleAdmin && item.from !== 2 && item.from !== 3">删除
                    </md-button>
                    <md-button class="md-primary" @click="showNameModifyDialog(item.serial_number)">
                        修改设备名称
                    </md-button>
                </md-table-cell>
            </md-table-row>

        </md-table>

        <div class="md-layout md-alignment-center-right" v-show="!searchResult">
            <md-button @click="gotoPageAt(page - 1)">上一页</md-button>
            <md-button @click="gotoPageAt(parseInt(page) + 1)">下一页</md-button>
            总计{{Math.floor(total / count) + (total % count === 0 ? 0 : 1)}}页，当前第{{page}}页

            <div class="md-layout-item md-size-15">
                <md-field>
                    <label for="count">每页显示条数</label>
                    <md-select v-model="count" name="count" id="count" @md-selected="deviceList">
                        <md-option value="15">每页显示15条</md-option>
                        <md-option value="30">每页显示30条</md-option>
                        <md-option value="60">每页显示60条</md-option>
                        <md-option value="100">每页显示100条</md-option>
                        <md-option value="200">每页显示200条</md-option>
                    </md-select>
                </md-field>
            </div>

            <div class="md-layout-item md-size-10" id="page_input">
                <md-field md-inline md-clearable>
                    <label>输入页数</label>
                    <md-input v-model="goPage" type="number"></md-input>
                </md-field>
            </div>
            <div class="md-layout-item md-size-10" id="device_page">
                <md-button class="md-accent md-raised md-dense" @click="gotoPage">跳转</md-button>
            </div>
        </div>

        <md-dialog-confirm
                :md-active.sync="dialogConfirm"
                md-title="确定要移除此设备吗？"
                md-content=""
                md-confirm-text="移除"
                md-cancel-text="取消"
                @md-cancel="onCancel"
                @md-confirm="onConfirm"/>

        <md-dialog :md-active.sync="showActivatedUsersDialog">
            <md-table>
                <md-table-row>
                    <md-table-head class="table_head">序号</md-table-head>
                    <md-table-head class="table_head">账号</md-table-head>
                    <md-table-head class="table_head">激活时间</md-table-head>
                    <md-table-head class="table_head">激活ip</md-table-head>
                    <md-table-head class="table_head">上次访问时间</md-table-head>
                    <md-table-head class="table_head">上次访问ip</md-table-head>
                </md-table-row>

                <md-table-row
                        v-for="(item, index) in activatedUsers"
                        v-bind:key="item.id">
                    <md-table-cell>{{ (index + 1)}}</md-table-cell>
                    <md-table-cell>{{ item.account }}</md-table-cell>
                    <md-table-cell>{{ new Date(item.active_time).toLocaleString() }}</md-table-cell>
                    <md-table-cell>{{ item.active_ip }}</md-table-cell>
                    <md-table-cell>{{ new Date(item.last_check_time).toLocaleString() }}</md-table-cell>
                    <md-table-cell>{{ item.last_check_ip }}</md-table-cell>
                </md-table-row>

            </md-table>
        </md-dialog>

        <md-dialog :md-active.sync="modifyNameDialog">
            <md-dialog-title>修改设备名称</md-dialog-title>
            <div class="content_input">
                <md-field>
                    <label>设备名称</label>
                    <md-input v-model="modifyNewName"></md-input>
                </md-field>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary md-raised" @click="modifyNameDialog = false">关闭</md-button>
                <md-button class="md-accent md-raised" @click="modifyDeviceName()">
                    修改
                </md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>

    </div>
</template>

<script>
    export default {
        name: "Devices",
        data: () => ({
            devices: {},
            filterDevices: {},
            allSelected: false,
            selectedDevices: [],
            newDeviceName: '',
            newDeviceSn: '',
            searchDeviceSn: '',
            page: 1,
            goPage: '',
            total: 0,
            count: 15,
            filter: '0',
            delIndex: -1,
            dialogConfirm: false,
            toast: false,
            toastMsg: "",
            activatedUsers: {},
            showActivatedUsersDialog: false,
            roleAdmin: false,
            fromWhere: 0,
            searchResult: false,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            filterTime: '',
            modifyNameDialog: false,
            modifyNameDeviceSn: '',
            modifyNewName: '',
        }),
        mounted() {
            let userInfo = JSON.parse(localStorage.getItem('user_info'));
            this.roleAdmin = userInfo.role === 1;
            this.page = 1;
            this.deviceList();
        },
        methods: {
            gotoPage: function () {
                if (this.goPage) {
                    this.page = this.goPage;
                    this.deviceList();
                } else {
                    this.showErrorTips('请输入页数');
                }
            },
            gotoPageAt: function (p) {
                if (p <= 0) p = 1;
                this.page = p;
                this.deviceList();
            },
            deviceList: function () {
                this.searchResult = false;
                let url;
                if (this.filterTime) {
                    if (this.$route.query.name) {
                        url = '/api/device/' + this.$route.params.company_id + '/?page=' + this.page + "&count=" + this.count + '&name=' + this.$route.query.name + "&from=" + this.fromWhere + "&start=" + this.filterTime[0].getTime() + "&end=" + this.filterTime[1].getTime()
                    } else {
                        url = '/api/device/' + this.$route.params.company_id + '/?page=' + this.page + "&count=" + this.count + "&from=" + this.fromWhere + "&start=" + this.filterTime[0].getTime() + "&end=" + this.filterTime[1].getTime()
                    }
                } else {
                    if (this.$route.query.name) {
                        url = '/api/device/' + this.$route.params.company_id + '/?page=' + this.page + "&count=" + this.count + '&name=' + this.$route.query.name + "&from=" + this.fromWhere
                    } else {
                        url = '/api/device/' + this.$route.params.company_id + '/?page=' + this.page + "&count=" + this.count + "&from=" + this.fromWhere
                    }
                }
                this.allSelected = false;
                this.selectedDevices.splice(0);
                this.$http.get(url).then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.devices = data.data.devices;
                                this.filterDevices = this.devices.slice();
                                this.filter = '0';
                                this.total = data.data.total;
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            getActivatedUsers(id) {
                this.$http.get('/api/device/active/' + id + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.activatedUsers = data.data.users;
                                this.showActivatedUsersDialog = true;
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            addDevice: function () {
                if (!this.newDeviceName) {
                    this.showErrorTips('请输入设备名称');
                    return
                }
                if (!this.newDeviceSn) {
                    this.showErrorTips('请输入设备序列号');
                    return
                }
                this.$http.post('/api/device/' + this.$route.params.company_id + '/' + this.newDeviceSn + '/' + this.newDeviceName + '/').then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('设备添加成功');
                                this.newDeviceName = '';
                                this.newDeviceSn = '';
                                this.page = 1;
                                this.deviceList();
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            lockUnlockDevice: function (sn, freeze) {
                this.$http.post('/api/device/freeze/' + this.$route.params.company_id + "/" + sn + '/' + freeze + '/').then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.deviceList();
                        } else {
                            this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                        }
                    } else {
                        this.showErrorTips('修改失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            lockUnlockDevices: function (freeze) {
                this.$http.post('/api/device/freeze/' + this.$route.params.company_id + '/' + freeze + '/', this.selectedDevices).then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.fromWhere = 0;
                            this.searchDeviceSn = '';
                            this.deviceList();
                        } else {
                            this.showErrorTips('修改失败，服务器返回错误码' + data.code);
                        }
                    } else {
                        this.showErrorTips('修改失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            deleteDeviceQuery: function (index) {
                this.delIndex = index;
                this.dialogConfirm = true;
            },
            searchDevice: function () {
                if (!this.searchDeviceSn) {
                    this.page = 1;
                    this.deviceList();
                    return
                }
                this.searchResult = true;
                this.$http.get('/api/device/search/' + this.searchDeviceSn + '/?company_id=' + this.$route.params.company_id + "&from=" + this.fromWhere).then(
                    response => {
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.filter = '0';
                                this.filterDevices = data.data.devices;
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            onConfirm() {
                if (this.delIndex >= 0)
                    this.deleteDevice(this.delIndex)
            },
            onCancel() {
            },
            deleteDevice: function (index) {
                this.$http.delete('/api/device/' + this.$route.params.company_id + '/' + this.filterDevices[index].serial_number + '/').then(
                    response => {
                        this.delIndex = -1;
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('设备删除成功');
                                this.page = 1;
                                this.deviceList();
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.delIndex = -1;
                    this.showErrorTips('未知错误' + error);
                })
            },
            deleteDevices: function () {
                this.$http.post('/api/device/delete/' + this.$route.params.company_id + '/', this.selectedDevices).then(response => {
                    if (response.status === 200) {
                        let data = response.data;
                        if (data.code === 0) {
                            this.page = 1;
                            this.showTips('设备删除成功');
                            this.deviceList();
                        } else {
                            if (data.code === 6500) {
                                this.showErrorTips('删除失败，没有可以删除的设备' + data.code);
                            } else {
                                this.showErrorTips('删除失败，服务器返回错误码' + data.code);
                            }
                        }
                    } else {
                        this.showErrorTips('删除失败，HTTP错误码' + response.status);
                    }
                }).catch(error => {
                    this.showErrorTips('未知错误' + error);
                })
            },
            showNameModifyDialog: function(sn) {
                this.modifyNameDeviceSn = sn;
                this.modifyNameDialog = true
            },
            modifyDeviceName: function () {
                this.$http.put('/api/device/name/' + this.$route.params.company_id + '/' + this.modifyNameDeviceSn + '/', {
                    deviceName: this.modifyNewName
                }).then(
                    response => {
                        this.modifyNameDialog = false
                        if (response.status === 200) {
                            let data = response.data;
                            if (data.code === 0) {
                                this.showTips('名称修改成功');
                                this.modifyNameDeviceSn = '';
                                this.modifyNewName = '';
                                this.page = 1;
                                this.deviceList();
                            } else {
                                this.showErrorTips('请求失败，服务器返回错误码' + data.code);
                            }
                        } else {
                            this.showErrorTips('请求失败，HTTP错误码' + response.status);
                        }
                    }
                ).catch(error => {
                    this.modifyNameDialog = false
                    this.showErrorTips('未知错误' + error);
                })
            },
            selectAll: function () {
                if (this.allSelected) {
                    this.selectedDevices.splice(0);
                    for (let i = 0; i < this.filterDevices.length; i++) {
                        this.selectedDevices.push(this.filterDevices[i].serial_number);
                    }
                } else {
                    this.selectedDevices.splice(0);
                }
            },
            changeSelect: function () {
                this.allSelected = this.selectedDevices.length === this.filterDevices.length;
            },
            showTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            showErrorTips: function (message) {
                this.toast = true
                this.toastMsg = message
            },
            getReadableFrom: function (from) {
                if (from === 1) {
                    return '用户未启用'
                } else if (from === 2) {
                    return 'App自动激活'
                } else if (from === -1) {
                    return 'EXCEL未启用'
                } else if (from === 3) {
                    return '用户已启用'
                } else {
                    return '未知'
                }
            },
        }
    }
</script>

<style scoped>
    .table_head {
        text-align: center;
    }

    #add_new {
        text-align: left;
    }

    #device_search {
        text-align: left;
    }

    #device_page {
        text-align: left;
        padding: 0;
    }

    #page_input {
        padding-right: 0;
    }

    .md-layout-item {
        padding: 0 10px;
    }

    #toolbar_show {
        background: antiquewhite;
    }

</style>